import axios from "axios"

const ArmoireService = {}

ArmoireService.ajouter =(formData,authorization)=>{
return axios.post(`${process.env.REACT_APP_API_URL}/armoire/ajouter`, formData ,{
    headers:{
    'Authorization': `Bearer ${authorization}` 
    }
})

}
export default ArmoireService ;